import { ReactElement } from 'react';
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';

import * as menuStyles from './Menu.styles';
import MenuListItems from '../MenuListItems';
import MenuTitle from '../MenuTitle';
import OrderButton from '../OrderButton';
import { AppContextField } from '../../../../context/app/types';
import { OrderMode } from '../../../Orders/utils';
import { OrderStep } from '../../../OrderBuilder/utils/formState';
import { PublicRoutePath } from '../../../../utils/routes';
import { clearCart } from '../../../../store/cart/actions';
import { deletePerform as logout } from '../../../../store/session/actions';
import { updateOrderSteps } from '../../../../context/app/actions';
import { useAppContextDispatch } from '../../../../context/app/AppContext';

export interface MenuProps {
  closeDrawer?: () => void;
}

function Menu({ closeDrawer }: MenuProps): ReactElement {
  const { classes } = menuStyles.useWrapper();

  const dispatch = useDispatch();
  const router = useRouter();

  const appDispatch = useAppContextDispatch();

  const regex = /orders\/.*(new|edit)/g;
  const disabledOrderNow = router.asPath.match(regex);

  /** This needs deprecating in favour of a simple URL state. */
  const handleOrderNow = () => {
    dispatch(clearCart());
    appDispatch(
      updateOrderSteps({
        [AppContextField.ORDER_MODE]: OrderMode.NEW,
        [AppContextField.ORDER_STEP]: OrderStep.DETAILS,
        [AppContextField.ORDER_ID]: undefined,
        [AppContextField.QUOTE_ID]: undefined,
      })
    );
  };

  /* const signoutCallback = () => setTimeout(() => window.location.assign(PublicRoutePath.HOME), 1000); */
  const signoutCallback = () => {
    void router.push(PublicRoutePath.HOME);
  };

  const handleSignout = () => {
    if (window.confirm('Are you sure?')) dispatch(logout({ callback: signoutCallback }));
  };

  return (
    <>
      <MenuTitle />
      <div role="navigation" aria-label="Main" className={classes.menu}>
        <MenuListItems onSignout={handleSignout} closeDrawer={closeDrawer} />
        <OrderButton
          disabled={!!disabledOrderNow}
          onClick={handleOrderNow}
          buttonClasses={classes.button}
          buttonTextClasses={classes.buttonText}
        />
      </div>
    </>
  );
}

export default Menu;
